/**
 * @prettier
 */

import {
    setIsDocSubmitted,
    setIsIdCaptureSupported,
    setIsPoaSubmitted,
} from "./configActions";
import selectStorage from "../../services/shared/selectStorage";
import {
    areCookiesEnabled,
    isActiveMobileHandoffSession,
} from "../../services/shared/helpers";

export function initialiseState(data) {
    return dispatch => {
        dispatch(setSubmissionState(data));
        dispatch(setCaptureMethod(data.screens.document_upload.capture_method));
        dispatch(setRetryLimit(data.state.document_upload.remaining));

        // Check if an ID has been submitted
        if (
            data.state.document_upload.completed ||
            data.state.document_upload.remaining <= 0
        ) {
            dispatch(setIsDocSubmitted(true));
        } else {
            dispatch(setIsDocSubmitted(false));
        }

        // Deal with cases when all attempts are used & doc upload is not set as complete
        // This happens with expired documents.
        if (data.state.document_upload.remaining <= 0) {
            dispatch(completeStage("document_upload"));
        }

        // Check if a poa doc has been submitted
        if (data.state.poa_upload.completed) {
            dispatch(setIsPoaSubmitted(true));
        } else {
            dispatch(setIsPoaSubmitted(false));
        }

        const storage = selectStorage(areCookiesEnabled());
        const isActiveHandoff = isActiveMobileHandoffSession(storage);

        dispatch(setIsMobileHandoffSubmission(isActiveHandoff));
        dispatch(isHandoff(isActiveHandoff));
        dispatch(
            setIsIdCaptureSupported(
                data.screens.document_upload.auto_capture,
                data.screens.document_upload.capture_method
            )
        );
        dispatch(
            setIsDocumentSelectionEnabled(
                data.screens.document_upload.id_document_selection
                    ? true
                    : false
            )
        );
        dispatch(
            setIsCountryRestrictionEnabled(
                data.screens.document_upload.country_id_selection ? true : false
            )
        );
        return dispatch({
            type: "COMPLETE",
        });
    };
}

export function setSubmissionState(data) {
    return {
        type: "SET_SUBMISSION_STATE",
        data: data,
    };
}

export function setCaptureMethod(data) {
    return {
        type: "SET_CAPTURE_METHOD",
        data: data,
    };
}

export function completeStage(stage) {
    return {
        type: "SET_STAGE_COMPLETED",
        data: stage,
    };
}

export function submissionAttempt(side) {
    return {
        type: "RECORD_SUBMISSION_ATTEMPT",
        data: side,
    };
}

export function isHandoff(bool) {
    return {
        type: "IS_HANDOFF",
        data: bool,
    };
}

export function setIsMobileHandoffSubmission(bool) {
    return {
        type: "IS_MOBILE_HANDOFF_SUBMISSION",
        data: bool,
    };
}

export function setRetryLimit(limit) {
    return {
        type: "SET_RETRY_LIMIT",
        data: limit,
    };
}

export function submissionStarted() {
    return {
        type: "SUBMISSION_STARTED",
    };
}

export function clearSubmissionState() {
    return {
        type: "CLEAR_SUBMISSION_STATE",
    };
}

export function setIsDocumentSelectionEnabled(isDocSelectionEnabled) {
    return {
        type: "IS_DOC_SELECTION_ENABLED",
        data: isDocSelectionEnabled,
    };
}

export function setIsCountryRestrictionEnabled(isCountryRestrictionEnabled) {
    return {
        type: "IS_COUNTRY_RESTRICTION_ENABLED",
        data: isCountryRestrictionEnabled,
    };
}

export function setIsPoaUploadInProgress(isPoaUploadInProgress) {
    return {
        type: "IS_POA_UPLOAD_IN_PROGRESS",
        data: isPoaUploadInProgress,
    };
}
